import { apiCall } from './gqlClient';

const GETFIREBASETOKEN_QUERY = `
  query getFirebaseToken {
    getFirebaseToken
    {
      firebaseToken
      ...fragments
    }
  }`;

export const getFirebaseTokenApiCall = async (fragments = null) => apiCall({ query: GETFIREBASETOKEN_QUERY, variables: {}, fragments });
